<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="DatumOd" name="txtDatumOd" [Label]="'STANJEPOVALUTAMA.DATUMOD.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
        <span *ngFor="let validation of errorMessages.DatumOd">
          <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.DatumOd.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="DatumDo" name="txtDatumDo" [Label]="'STANJEPOVALUTAMA.DATUMDO.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumDo.invalid">
        <span *ngFor="let validation of errorMessages.DatumDo">
          <span class="error-message" *ngIf="fc.DatumDo.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.DatumDo.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
  
 
  <div class="row mt-2">
      <div class="col-md-12">  
        <button type="button" class="btn btn-primary" (click)="LoadData()">
          Učitaj podatke
        </button>
      </div>
  </div>
</form>
<div class="row mt-4">
  <div class="col-12">
    <ngb-tabset [destroyOnHide]="false">
      <ngb-tab title="Tabela">
        <ng-template ngbTabContent>
          <yt-fw-default-table
            *ngIf="modelData!=null && modelData.MainList!=null"
            [Config]="Config"
            [Items]="items"
            [TableColumns]="modelData.MainList.TableColumns"      
            [Condensed]="CondensedTable"
            [ShowLoader]="MainItemsLoading"
            (RefreshDataClicked)="RefreshData()"
          >
          </yt-fw-default-table>
        </ng-template>
      </ngb-tab>
      <ngb-tab title="Grafikon">
        <ng-template ngbTabContent>
          <yt-chart
            *ngIf="ItemsLoaded | async"
            [ValueColumnName]="'Ukupno'"
            [LabelColumnName]="'Datum'"
            [Type]="'bar'"
            [Data]="chartItems"
            [Series]="'Ukupno'"
            [Width]="1270"
            [Height]="400">
          </yt-chart>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</div>


